import { MerchantParams } from './MerchantParser';
import AppBar from '../../components/shared/AppBar/AppBar';
import NavigationUtils from '../../utils/navigation.utils';
import style from '../InstallmentsPage/InstallmentsPage.css';
import LoadingScreen from '../../components/shared/LoadingScreen/LoadingScreen';
import MerchantPageView from '../../components/Merchant/MerchantPageView';
import { useEffect, useRef, useState } from 'preact/hooks';
import CardService from '../../services/card.service';

export default function MerchantPage() {
  const backRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [settings, setSettings] = useState({});
  const currentParams = new URLSearchParams(window.location.search);
  const organizationCode = currentParams.get(MerchantParams.ORGANIZATION_CODE);

  useEffect(() => {
    CardService.getSettings(organizationCode)
      .then(({ data }) => {
        setSettings(data);
        setLoading(false);
      })
      .catch((e) => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  return (
    <>
      <AppBar
        onBackClick={() => {
          NavigationUtils.back();
        }}
        onCloseClick={() => {
          NavigationUtils.endFlow();
        }}
        backRef={backRef}
        className="fixed-bar"
      />
      <div className={style.container}>
        {loadingScreen ? (
          <LoadingScreen />
        ) : (
          <MerchantPageView
            settings={settings}
            className={style.content}
            organizationCode={organizationCode}
          />
        )}
      </div>
    </>
  );
}
